// This adds margin bottom to the footer if the "risk warning" banner is set to fixed on the homepage.
$.fn.setFooterBottomMargin = function(footer) {
    var bannerHeight = $(this).css( "height" );
    $(footer).css('margin-bottom', bannerHeight);
}

// Gets the height of the banner and applies that amount of space to the bottom margin of the footer
$(window).load(function () {
    $('.disclaimer-sticky').setFooterBottomMargin('.sticky-disclaimer-margin');
})

// Whenever the window is resized we check the size of the banner again
$( window ).resize(function() {
    resizeBounce();
});

var resizeBounce = debounce(function() {
    if($('.disclaimer-sticky').css("height") != ($('.sticky-disclaimer-margin').css("margin-bottom")))
    $('.disclaimer-sticky').setFooterBottomMargin('.sticky-disclaimer-margin');
}, 200);
//# sourceMappingURL=disclaimerBanner.js.map
